const enabled = import.meta.env.DEV && import.meta.env.MODE !== "test";

export const storefrontDevLog = (event: string, details?: unknown) => {
  if (!enabled) return;
  if (details === undefined) console.info(`[storefront] ${event}`);
  else console.info(`[storefront] ${event}`, details);
};
